import type { PLATFORM_TYPE } from '@/enums/purchase'

import { ResponseDto } from '@/api/server/common/dto'

export class TicketAbleTimePathVar {
  seq!: number
  endTime?: Date
}

export class ShareTicketAbleTimePathVar extends TicketAbleTimePathVar {}

export class ShareTicketAbleTimeResDto extends ResponseDto {
  data!: {
    times: ShareAbleTime[]
  }
}

export interface ShareAbleTime {
  usingTime: number
  price: number
}

export interface AbleTime {
  title: string
  predictBeginTime: string
  predictEndTime: string
}

export class TicketDailyAbleTimeResDto extends ResponseDto {
  data!: {
    times: AbleTime[]
  }
}

export interface MonthlyAbleDate {
  startDate: Date
  endDate: Date
  usingDayCount: number
  partiallyDayCount: number
  partiallyDayPrice: number
  maxCount: number
  soldCount: number
  isSoldOut: boolean
  unitPrice: number
  totalPrice: number
}

export class TicketMonthlyAbleTimeResDto extends ResponseDto {
  data!: {
    dates: MonthlyAbleDate[]
  }
}

export interface RequestPaymentPathVar {
  pgType: string
}

interface defaultRequestPaymentPayload {
  point: number
  price: number
  totalPrice: number
  authCodeSeq: number
  platform: PLATFORM_TYPE.WEB
  carNum: string
}
export interface ParkinglotRequestPaymentPayload extends defaultRequestPaymentPayload {
  couponSeq: number
  predictBeginTime: Date
  predictEndTime: Date
  predictExitBeginTime?: Date
  predictExitEndTime?: Date
}

export interface SharedParkinglotRequestPaymentPayload extends defaultRequestPaymentPayload {
  shareSeq: number // 공유주차장 seq
  usingTime: number
}

export interface ExtensionSharedParkinglotRequestPaymentPayload
  extends Omit<SharedParkinglotRequestPaymentPayload, 'totalPrice' | 'price' | 'carNum' | 'authCodeSeq'> {
  parkingSeq: number // 내주차권 seq
}

export interface RequestPaymentAuth {
  token: string
}
export interface RequestAuth {
  accessToken: string
}

export class PaymentResDto extends ResponseDto {
  data!: {
    redirectUrl: string
    successUrl: string
  }
}

export class RequestAuthGuestPayload {
  guestSeq!: number
}

export class RequestVerifyCodePayload {
  authCodeSeq!: number
  code!: string
  phone!: string
}

export class RequestAuthCodePayload {
  phone!: string
}

export class RequestAuthCodeResDto extends ResponseDto {
  data!: {
    authCodeSeq: number
  }
}

export class RequestAuthGuestResDto extends ResponseDto {
  data!: {
    accessToken: string
    refreshToken: string
  }
}
